import { ICreatePublicReservation, IPublicRestaurant, IRestaurantAvailableTimes, Rest } from '@localina/core';
import { IBaseReservation, ILocalinaWidgetApi, IRestaurantPublicMenu, IShiftOverview } from '../../interfaces';
import { WidgetApiConstants } from '../../utils';

export class LocalinaWidgetApi implements ILocalinaWidgetApi {
    async getRestaurantConfiguration(restaurantId: string): Promise<IPublicRestaurant> {
        return Rest.getRequest(WidgetApiConstants.getRestaurantConfiguration(restaurantId).toString());
    }

    async getRestaurantMenu(restaurantId: string): Promise<IRestaurantPublicMenu> {
        return Rest.getRequest(WidgetApiConstants.getRestaurantPublicMenu(restaurantId).toString());
    }

    async getAvailableAreaTimes(
        restaurantId: string,
        participants: number,
        reservationDateTime: string,
        shiftId: string,
        areaId: string,
        expectedOccupancyTime?: number,
    ): Promise<IRestaurantAvailableTimes> {
        return await Rest.getRequest(
            WidgetApiConstants.getRestaurantAvailableAreaTimes(
                restaurantId,
                participants,
                reservationDateTime,
                shiftId,
                areaId,
                expectedOccupancyTime,
            ).toString(),
        );
    }

    async saveReservation(restaurantId: string, reservation: ICreatePublicReservation): Promise<string> {
        return Rest.postRequest({
            url: WidgetApiConstants.saveReservation(restaurantId).toString(),
            payload: reservation,
        });
    }

    async getShifts(restaurantId: string, date: string, participants: number): Promise<IShiftOverview[]> {
        const res: IShiftsRes = await Rest.getRequest(
            WidgetApiConstants.getShifts(restaurantId, date, participants).toString(),
        );
        return res.workingHours;
    }

    async getReservation(restaurantId: string, token: string): Promise<IBaseReservation | undefined> {
        return await Rest.getRequest(WidgetApiConstants.getReservation(restaurantId, token).toString());
    }

    async cancelReservation(restaurantId: string, token: string): Promise<void> {
        return await Rest.putRequest({
            url: WidgetApiConstants.getReservation(restaurantId, token).toString() + '/cancel',
            payload: undefined,
        });
    }
}

interface IShiftsRes {
    workingHours: IShiftOverview[];
}
